<template>
  <v-app :style="{ background: $vuetify.theme.themes[theme].background }">
    <v-app-bar absolute color="blue darken-4" prominent class="white--text">
      <v-spacer></v-spacer>
      <v-toolbar-title>Chup Chaap</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon href="https://www.instagram.com/chupchaap.io" target="_blank">
        <v-icon class="white--text">mdi-instagram</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col>
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-bottom-navigation app dark color="primary">
      <div class="d-flex align-center"></div>

      <v-spacer></v-spacer>

      <v-btn
        to="/about"
        target="_blank"
        text
      >
        <span class="mr-2 white--text">About</span>
      </v-btn>


      <v-btn
        to="/rules"
        target="_blank"
        text
      >
        <span class="mr-2 white--text">Rules</span>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script>
export default {
  name: "App",
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
};
</script>
